<template>
    <b-row v-bind:class="{'detail-visible': showDetailPage}">
        <b-col>
          <support-ticket-detail-breadcrumb
            v-bind:class="{'detail-visible': showDetailPage}"
            v-bind:name="supportTicketDetail.data.title"
          >
          </support-ticket-detail-breadcrumb>

          <support-ticket-detail-default></support-ticket-detail-default>
        </b-col>
    </b-row>
</template>

<script>

import { mapState } from 'vuex'

import SupportTicketDetailDefault from './SupportTicketDetailDefault'
import SupportTicketDetailBreadcrumb from './SupportTicketDetailBreadcrumb'

export default {

  name: 'SupportTicketDetail',

  components: {
    SupportTicketDetailDefault,
    SupportTicketDetailBreadcrumb
  },

  computed: {

    ...mapState('support', [
      'supportTicketDetail',
      'showDetailPage'
    ])
  }
}
</script>
